export const invoicePurchaseStatuses = ['toCheck', 'paused', 'checked'] as const;

export type InvoicePurchaseStatus = typeof invoicePurchaseStatuses[number];
